import PropTypes from 'prop-types';
import classNames from 'classnames';

import GridInfoBlock from './GridInfoBlock/GridInfoBlock';

import styles from './GridInfo.module.scss';

const GridInfo = ({ items = [], className = '' }) => {
  return (
    <div className={classNames(styles['grid-info'], className)}>
      {items.map((item, index) => {
        const { className: itemClassName, ...itemProps } = item;
        const blockClassName = classNames(
          styles[`grid-info__block-${index + 1}`],
          itemClassName
        );

        return (
          <GridInfoBlock
            key={index}
            className={blockClassName}
            {...itemProps}
          />
        );
      })}
    </div>
  );
};

GridInfo.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      title: PropTypes.string.isRequired,
      label: PropTypes.string,
      description: PropTypes.string,
      cta: PropTypes.shape({
        url: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        type: PropTypes.oneOf(['button', 'link']),
        onClick: PropTypes.func
      }),
      renderImage: PropTypes.func,
      hideImageOnMobile: PropTypes.bool,
      hideTitleOnMobile: PropTypes.bool
    })
  ).isRequired,
  className: PropTypes.string
};

export default GridInfo;
